import Base from './Base';
import OrderStatus from './OrderStatus';

export const orderTrackingColors = {
  archived: '#ADABAB',
  cancelled: '#D72D1E',
  complete: '#48BF83',
  demo: '#F19100',
  paid: '#3D98D6',
  registered: '#B91ED7',
};
export const orderTrackingStatuses = {
  archived: new OrderStatus({ label: 'Archived', value: 'archived' }),
  cancelled: new OrderStatus({ label: 'Cancelled', value: 'cancelled' }),
  complete: new OrderStatus({ label: 'Completed', value: 'complete' }),
  demo: new OrderStatus({ label: 'Demo', value: 'demo' }),
  paid: new OrderStatus({ label: 'Paid', value: 'paid' }),
  registered: new OrderStatus({ label: 'Registered', value: 'registered' }),
};
export const mapOrderField = (field) => {
  const mapping = {
    status: 'case.status',
  };
  return mapping[field] || field;
};

export const mapAvailableOptions = (status, paymentDetailsFound = false) => {
  const dynamicOptions = [orderTrackingStatuses.registered];
  if (paymentDetailsFound) {
    dynamicOptions[0] = orderTrackingStatuses.paid;
  }

  const options = {
    archived: [orderTrackingStatuses.cancelled, ...dynamicOptions],
    cancelled: [orderTrackingStatuses.archived, ...dynamicOptions],
    demo: [orderTrackingStatuses.archived, orderTrackingStatuses.cancelled],
    paid: [orderTrackingStatuses.cancelled, orderTrackingStatuses.archived],
    registered: [orderTrackingStatuses.cancelled, orderTrackingStatuses.archived],
  };

  return options[status] || [];
};

export default class Order extends Base {
  id = 0;
  workspace = null;
  name = '';
  email = '';
  createdAt;
  packageName = '';
  packagePrice = '';
  plan = null;
  status = orderTrackingStatuses.registered;
  clinicCode = '';
  clinicName = '';
  clinicSubdomain = '';
  gclid = '';

  constructor(source) {
    super();
    this.clone(source);
    this.createdAt = this.createdAt ? new Date(this.createdAt) : null;
    this.status = orderTrackingStatuses[this.firstOrderStatus];
    this.clinicCode = source?.referenceWorkspace?.clinicCode;
    this.clinicName = source?.referenceWorkspace?.name;
    this.clinicSubDomain = source?.referenceWorkspace?.subdomain;
    this.packageName = this.plan?.name;
    this.packagePrice = '-';
  }

  get statusColor() {
    if (!this?.status?.value) return '#00000000';
    return orderTrackingColors[this.status.value];
  }

  get workspaceName() {
    return this.workspace && this.workspace.name;
  }
}
